import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/course-student/empty-quiz.svg'


const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = {
  key: 0,
  id: "card-performance"
}
const _hoisted_3 = { class: "w-full mt-16 p-2 md:p-0 space-y-4" }
const _hoisted_4 = { class: "text-[24px] font-[500]" }
const _hoisted_5 = ["initial", "enter"]
const _hoisted_6 = { class: "w-full sm:w-[40%] bg-white h-[140px] shadow-md rounded-md flex flex-row hover:bg-h-primary-50 hover:shadow-lg hover:cursor-pointer sm:min-w-[360px]" }
const _hoisted_7 = { class: "flex flex-row items-center gap-3 p-4 h-[80px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-[#E6EFF9] h-[1px] w-full" }, null, -1)
const _hoisted_9 = { class: "flex items-center h-[60px] px-4" }
const _hoisted_10 = {
  key: 1,
  class: "w-full mt-8 pb-20 overflow-x-auto sm:px-0 px-2 space-y-8"
}
const _hoisted_11 = { class: "text-[24px] font-[500]" }
const _hoisted_12 = ["initial", "enter"]
const _hoisted_13 = { class: "flex flex-row justify-between bg-white md:w-[426px] w-full h-[97px] rounded-md shadow-md p-4 border-b-4 border-h-primary-500" }
const _hoisted_14 = { class: "h-full flex flex-col justify-between" }
const _hoisted_15 = { class: "text-[16px]" }
const _hoisted_16 = { class: "text-[20px] font-[500]" }
const _hoisted_17 = { class: "flex flex-row justify-between bg-white w-full md:w-[426px] sm:h-[97px] rounded-md shadow-md p-4 border-b-4 border-h-primary-500" }
const _hoisted_18 = { class: "h-full flex flex-col justify-between" }
const _hoisted_19 = { class: "text-[16px]" }
const _hoisted_20 = { class: "text-[20px] font-[500]" }
const _hoisted_21 = ["initial", "enter"]
const _hoisted_22 = { class: "text-[16px] font-[800]" }
const _hoisted_23 = { class: "text-[16px] font-[800]" }
const _hoisted_24 = { class: "text-[16px] font-[800]" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px] font-[800]" }, "Status", -1)
const _hoisted_26 = ["initial", "enter"]
const _hoisted_27 = { class: "text-[16px] font-[600]" }
const _hoisted_28 = { class: "text-[16px] font-[600]" }
const _hoisted_29 = { class: "text-[16px] font-[600]" }
const _hoisted_30 = ["initial", "enter"]
const _hoisted_31 = { class: "text-[14px] font-[800]" }
const _hoisted_32 = { class: "font-[600]" }
const _hoisted_33 = { class: "text-[14px] font-[800]" }
const _hoisted_34 = { class: "font-[600]" }
const _hoisted_35 = { class: "text-[14px] font-[800]" }
const _hoisted_36 = { class: "font-[600]" }
const _hoisted_37 = { class: "text-[14px] font-[800]" }
const _hoisted_38 = ["initial", "enter"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty-quiz"
}, null, -1)
const _hoisted_40 = { class: "font-[700] text-[14px] text-gray-600 mt-8" }
const _hoisted_41 = { class: "font-[600] text-[14px] text-gray-600 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseLearningMapStudent = _resolveComponent("CourseLearningMapStudent")!
  const _component_MagicSvg = _resolveComponent("MagicSvg")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.typeCourse === 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showLearningMapStudent)
            ? (_openBlock(), _createBlock(_component_CourseLearningMapStudent, {
                key: 0,
                onOnCloseMap: _ctx.closeMapStudent
              }, null, 8, ["onOnCloseMap"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Meu desempenho",
              en: "My performance",
            })), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "w-full mt-8 pb-8 overflow-x-auto sm:px-0 px-2 space-y-8",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion(100)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "flex-1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLearningMapStudent = true))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_MagicSvg, {
                    id: "custom-quiz-svg",
                    path: "course-student/icon-card.svg",
                    color: "text-h-primary-50 stroke-h-primary-900"
                  }),
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Mapa de conteúdos",
                    en: "Content map",
                  })), 1)
                ]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Visualize e acesse tudo que você ja completou no curso",
                    en: "Visualize and access",
                  })), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLearningMapStudent = true)),
                class: "bg-h-primary-500 w-[58px] sm:w-[80px] rounded-r-md text-white flex justify-center items-center"
              }, [
                _createVNode(_component_v_icon, {
                  name: "md-arrowforward",
                  class: "text-white"
                })
              ])
            ])
          ], 8, _hoisted_5)), [
            [_directive_motion]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
    (!_ctx.loader && _ctx.quizResult.completedLearningObjectives > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Histórico no quiz",
            en: "Quiz history",
          })), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "flex flex-col md:flex-row w-full space-y-2 md:space-y-0 md:space-x-4",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion(0)
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Média de acertos nos quizzes",
                  en: "Average scores on quizzes",
                })), 1),
                _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.quizResult.average === 0 || _ctx.quizResult.average === undefined
                  ? "-"
                  : Math.ceil(_ctx.quizResult.average) + "%"), 1)
              ]),
              _createVNode(_component_MagicSvg, {
                id: "custom-quiz-svg",
                path: "course-student/quiz-average.svg",
                color: "text-h-primary-50 stroke-h-primary-900"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Objetivos de aprendizagens finalizados",
                  en: "Completed learning objectives",
                })), 1),
                _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.quizResult.completedLearningObjectives === 0
                  ? "-"
                  : _ctx.quizResult.completedLearningObjectives), 1)
              ]),
              _createVNode(_component_MagicSvg, {
                id: "custom-quiz-svg",
                path: "course-student/objective-complete.svg",
                color: "text-h-primary-50 stroke-h-primary-900"
              })
            ])
          ], 8, _hoisted_12)), [
            [_directive_motion]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion(100),
            class: "mt-4 grid-cols-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md w-full max-w-full hidden sm:grid"
          }, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("labels.generic", { pt: "Capítulo", en: "Chapter" })), 1),
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("labels.generic", { pt: "Objetivo de aprendizagem", en: "Learning Object" })), 1),
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("labels.generic", { pt: "Percentual de acertos", en: "Percentage of correct answers" })), 1),
            _hoisted_25
          ], 8, _hoisted_21)), [
            [_directive_motion]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizResult?.quizRecords, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: `desktop-${i}`,
              initial: _ctx.initialMotion,
              enter: _ctx.enterMotion.getEnterMotion((i + 1) * 100),
              class: "mt-4 grid-cols-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md w-full max-w-full hidden sm:grid"
            }, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(item.chapterName), 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(item.objectiveName), 1),
              _createElementVNode("p", _hoisted_29, _toDisplayString(Math.ceil(item.percentage) + "%"), 1),
              _createElementVNode("p", {
                class: _normalizeClass(`flex justify-center rounded-lg p-1 items-center text-[12px] font-[600] w-[68px] ${
            item.status === 'PASSED'
              ? 'bg-h-success-100 text-h-success-500'
              : 'bg-h-warning-100 text-h-warning-800'
          }`)
              }, _toDisplayString(item.status === "PASSED" ? "Aprovado" : "Reprovado"), 3)
            ], 8, _hoisted_26)), [
              [_directive_motion]
            ])
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizResult?.quizRecords, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: `mobile-${i}`,
              initial: _ctx.initialMotion,
              enter: _ctx.enterMotion.getEnterMotion((i + 1) * 100),
              class: "sm:hidden mt-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md space-y-2"
            }, [
              _createElementVNode("p", _hoisted_31, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Capítulo", en: "Chapter" })) + ": ", 1),
                _createElementVNode("span", _hoisted_32, _toDisplayString(item.chapterName), 1)
              ]),
              _createElementVNode("p", _hoisted_33, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Objetivo de aprendizagem", en: "Learning Object" })) + ": ", 1),
                _createElementVNode("span", _hoisted_34, _toDisplayString(item.objectiveName), 1)
              ]),
              _createElementVNode("p", _hoisted_35, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Percentual de acertos", en: "Percentage of correct answers" })) + ": ", 1),
                _createElementVNode("span", _hoisted_36, _toDisplayString(Math.ceil(item.percentage) + "%"), 1)
              ]),
              _createElementVNode("p", _hoisted_37, [
                _createTextVNode(" Status: "),
                _createElementVNode("span", {
                  class: _normalizeClass(`ml-2 px-2 py-[2px] rounded-sm text-[12px] font-[600] ${
              item.status === 'PASSED'
                ? 'bg-h-success-200 text-h-success-700'
                : 'bg-h-warning-100 text-h-warning-500'
            }`)
                }, _toDisplayString(item.status === "PASSED" ? "Aprovado" : "Reprovado"), 3)
              ])
            ], 8, _hoisted_30)), [
              [_directive_motion]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loader && _ctx.quizResult.completedLearningObjectives === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 2,
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion.getEnterMotion(0),
          class: "w-full flex flex-col justify-center items-center mt-16 md:min-h-[50vh]"
        }, [
          _hoisted_39,
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nenhum quiz feito", en: "No quiz taken" })), 1),
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Você ainda não fez nenhum quiz, os seus resultados ficarão aqui.",
            en: "You haven't taken any quiz yet, your results will be here.",
          })), 1)
        ], 8, _hoisted_38)), [
          [_directive_motion]
        ])
      : _createCommentVNode("", true)
  ]))
}